import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { TestFormdataService } from './Testformdata.service';

@Injectable({
  providedIn: 'root'
})
export class AuthserviceService {

  //private apiUrl = "http://34.192.172.139:5000/";

   private Url = environment.apiUrl;
  private tokenSubject = new BehaviorSubject<string | null>(this.getToken());
  private loggedInSubject = new BehaviorSubject<any | null>(this.getToken());
  http = inject(HttpClient);
  router = inject(Router);
  formDataService = inject(TestFormdataService);

   login(credentials: { userName: string; password: string, userRole: number }): Observable<any> {
    return this.http.post<any>(`${this.Url}auth/login`, credentials).pipe(
      tap(response => {
        localStorage.setItem('token', response.token);
        //localStorage.setItem('token', "token");
        //localStorage.setItem('user', response);
        this.tokenSubject.next("token");
        console.log('Login API Response:', response); // Debugging response  
        this.loggedInSubject.next(response);
      })
    );
  }


  getUserId(): Observable<any> {
    return this.http.get<any>(`${this.Url}auth/getUserId`).pipe(
      tap(response => {
        console.log('getuserid', response)
      })
    );
  }

  logout(): void {
 
    const datas = this.formDataService.getFormData();
  
    this.http.get<any>(`${this.Url}auth/logout?UserName=${datas.userName}`).subscribe({
      next: () => {
        // API call was successful, now clear local storage
        localStorage.removeItem('token');
        this.formDataService.clear();
        localStorage.removeItem('user');
        this.loggedInSubject.next(null);
  
        // Redirect to login page
        this.router.navigate(['/Login']);
      },
      error: (err) => {
        console.error('Logout failed:', err);
        // Handle error if needed (e.g., show an error message)
      }
    });
  }

  getToken(): string | null {
    return localStorage.getItem('token');
  }
  getLoggenInUserDetails(): any | null {
    const userDetails = this.loggedInSubject.getValue();
    if (!localStorage.getItem('user') || localStorage.getItem('user')?.trim() === "") {
    localStorage.setItem('user', JSON.stringify(userDetails));
    }
    console.log('Logged-in user details:', userDetails); // Debugging
    return   JSON.parse(localStorage.getItem('user') || '{}');
  }
  isAuthenticated(): boolean {
    return !!this.getToken();
  }
}
